export const QR_PREFIX = 'HELPORT:';

export function normalizeEmployeeId(value) {
  return String(value || '').replace(/[\r\n]/g, '').trim().toUpperCase();
}

export function buildQrAttendancePayload(employeeId) {
  const uid = normalizeEmployeeId(employeeId);
  return uid ? `${QR_PREFIX}${uid}` : '';
}

export function parseQrAttendancePayload(raw) {
  const cleaned = String(raw || '').replace(/[\r\n]/g, '').trim();
  if (!cleaned) return '';

  const upper = cleaned.toUpperCase();
  if (upper.startsWith(QR_PREFIX)) {
    return normalizeEmployeeId(upper.slice(QR_PREFIX.length));
  }

  return normalizeEmployeeId(upper);
}

export function findEmployeeByUid(employees, rawUid) {
  const uid = parseQrAttendancePayload(rawUid);
  if (!uid || !Array.isArray(employees)) return null;

  return employees.find((emp) => {
    const employeeUid = normalizeEmployeeId(emp.employeeId);
    const employeeEid = normalizeEmployeeId(emp.eid);
    return employeeUid === uid || (employeeEid && employeeEid === uid);
  }) || null;
}
